import React from 'react';
import Icon from '@components/AppIcon';
import Button from '@components/ui/Button';

const SpecialtyFilter = ({ specialties, activeFilter, onFilterChange }) => {
  // Count specialists by category
  const countBySpecialty = {
    'all': specialties.length,
    'cataract': specialties.filter(doctor => 
      doctor.specialty.toLowerCase().includes('cataract') || 
      doctor.specializations.some(spec => spec.toLowerCase().includes('cataract'))
    ).length,
    'lasik': specialties.filter(doctor => 
      doctor.specialty.toLowerCase().includes('lasik') || 
      doctor.specializations.some(spec => spec.toLowerCase().includes('lasik'))
    ).length,
    'retina': specialties.filter(doctor => 
      doctor.specialty.toLowerCase().includes('retina') || 
      doctor.specialty.toLowerCase().includes('vitreoretina') || 
      doctor.specializations.some(spec => spec.toLowerCase().includes('retina'))
    ).length,
    'glaucoma': specialties.filter(doctor => 
      doctor.specialty.toLowerCase().includes('glaucoma') || 
      doctor.specializations.some(spec => spec.toLowerCase().includes('glaucoma'))
    ).length,
  };

  const allSpecialties = [
    { id: 'all', name: 'All Specialists', icon: 'Users', count: countBySpecialty.all },
    { id: 'cataract', name: 'Cataract Surgery', icon: 'Eye', count: countBySpecialty.cataract },
    { id: 'lasik', name: 'LASIK & Refractive', icon: 'Zap', count: countBySpecialty.lasik },
    { id: 'retina', name: 'Retinal Specialists', icon: 'Target', count: countBySpecialty.retina },
    { id: 'glaucoma', name: 'Glaucoma Treatment', icon: 'Shield', count: countBySpecialty.glaucoma },
  ];

  return (
    <div className="bg-white py-8 border-b">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Heading */}
        <div className="text-center mb-8">
          <h2 className="font-heading font-bold text-2xl lg:text-3xl text-text-primary mb-4" style={{ color: "#08005f" }}>
            Find Your Specialist
          </h2>
          <p className="text-text-secondary max-w-2xl mx-auto">
            Our team of internationally trained specialists covers every aspect of eye care, 
            from routine check-ups to complex surgical procedures.
          </p>
        </div>

        {/* Desktop Filter Buttons */}
        <div className="hidden lg:flex flex-wrap justify-center gap-3">
          {allSpecialties.map((specialty) => (
            <button
              key={specialty.id}
              onClick={() => onFilterChange(specialty.id)}
              className={`flex items-center space-x-2 px-4 py-3 rounded-lg medical-transition ${
                activeFilter === specialty.id
                  ? 'bg-[#eb2227] text-white shadow-md'
                  : 'bg-muted text-text-primary hover:bg-[#08005f]/10'
              }`}
            >
              <Icon name={specialty.icon} size={16} />
              <span className="font-medium text-sm">{specialty.name}</span>
              <span
                className={`text-xs px-2 py-1 rounded-full ${
                  activeFilter === specialty.id
                    ? 'bg-white/20 text-white'
                    : 'bg-text-secondary/10 text-text-secondary'
                }`}
              >
                {specialty.count}
              </span>
            </button>
          ))}
        </div>

        {/* Mobile Filter Dropdown */}
        <div className="lg:hidden">
          <div className="relative">
            <select
              value={activeFilter}
              onChange={(e) => onFilterChange(e.target.value)}
              className="w-full px-4 py-3 bg-muted rounded-lg text-text-primary font-medium appearance-none cursor-pointer"
            >
              {allSpecialties.map((specialty) => (
                <option key={specialty.id} value={specialty.id}>
                  {specialty.name} ({specialty.count})
                </option>
              ))}
            </select>
            <Icon 
              name="ChevronDown" 
              size={20} 
              className="absolute right-4 top-1/2 transform -translate-y-1/2 text-text-secondary pointer-events-none" 
            />
          </div>
        </div>

        {/* Quick Actions */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mt-8">
          <Button
            variant="outline"
            className="hover:bg-[#08005f] hover:text-white transition"
            iconName="Search"
            iconPosition="left"
            iconSize={16}
          >
            Search by Name
          </Button>
          <Button
            variant="outline"
            className="hover:bg-[#08005f] hover:text-white transition"
            iconName="MapPin"
            iconPosition="left"
            iconSize={16}
          >
            Find by Location
          </Button>
          <Button
            variant="outline"
            className="hover:bg-[#08005f] hover:text-white transition"
            iconName="Clock"
            iconPosition="left"
            iconSize={16}
          >
            Available Today
          </Button>
        </div>
      </div>
    </div>
  );
};

export default SpecialtyFilter;